import { GetGlobalCurrentPageData } from "../Utilities/WindowUtils";

export default function isValidLocation(location:any){ 

    if(GetGlobalCurrentPageData().isDuplicateAllLocationPage)
        return (location.selected == true||location.isSelected);
    else
        return true;

}